export const SKILL_DESCRIPTION_MAX = 1000;
